export default "__VITE_ASSET__CfPu23NC__"